<template>
  <button class="xt-button" :disabled="disabled" :class="extraClass" @click="handleClick">
    <slot/>
  </button>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isCube: {
      type: Boolean,
      default: false
    },
    // 加了线条 line
    buttonType: {
      type: '',
      default: '',
    },
    //  primary, success
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    extraClass() {
      let classes = ''
      if (this.isCube) {
        if (this.type === 'primary') {
          classes = 'cube primary '
        } else {
          classes = 'cube none '
        }
      }
      if (this.buttonType) {
        classes += `button-${this.buttonType}`
      }
      if (this.disabled) {
        classes += 'disabled'
      }
      return classes
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>
<style scoped lang="less">
@import '../css/mobile.less';

.xt-button {
  width: 100%;
  height: 46px;
  border-radius: 70px;
  max-width: 270px;
  margin: 0 auto;
  display: block;
  font-size: 18px;
  font-weight: 500;
  color: @white-text-color;
  outline: none;
  box-shadow: none;
  border: none;
  user-select: none;
  background: linear-gradient(228deg, rgba(130, 176, 239, 1) 0%, rgba(78, 130, 203, 1) 51%, rgba(70, 115, 182, 1) 100%);
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &:active {
    background: linear-gradient(320deg, rgba(130, 176, 239, 1) 0%, rgba(78, 130, 203, 1) 51%, rgba(70, 115, 182, 1) 100%);
  }
  
  &.button-line {
    background: #fff;
    color: #4e82cb;
    border: 1px solid #4e82cb;
  }

  &.disabled {
    cursor: not-allowed;
    background: @disable-button-color;
    border-color: @disable-button-color;
    color: @white-text-color;
  }

  &.cube {
    width: 125px;
    height: 54px;
    padding: 15px;
    text-align: center;
    font-size: 18px;
    border-radius: 0;

    &.primary {
      background: @primary-color;
      color: #FFFFFF;
      &:active {
        background: #3C5EA5;
      }
      &.disabled {
        background: @disable-button-color;
        color: @white-text-color;
      }
    }

    &.none {
      background: rgba(255, 255, 255, 1);
      color: @primary-color;
      border-top: 1px solid #E8E8E8;
      &:active{
        background: rgba(51, 51, 51, 0.1);
      }
      &.disabled {
        color: #999999;
      }
    }
  }
}
</style>